// extracted by mini-css-extract-plugin
module.exports = {"container":"Qwwwz","link":"_2FKyG","term":"PXbPC"};